import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "@/app/store.ts";
import { components } from "@/types/generated/api-schema.ts";
import { api } from "@/services/apis/api.ts";
type Workspace = components["schemas"]["Workspace"];

const initialState: { selectedWorkspace?: Workspace } = {
    selectedWorkspace: undefined, // or any default value
};

const workspaceSlice = createSlice({
    name: "workspace",
    initialState,
    reducers: {
        setSelectedWorkspace(state, action) {
            state.selectedWorkspace = action.payload;
        },
        workspaceUnavailable(state, action: PayloadAction<string>) {
            // A delayed failure from the previous workspace must not clear a
            // selection the user has already changed.
            if (state.selectedWorkspace?.id === action.payload) {
                state.selectedWorkspace = undefined;
            }
        },
    },
    extraReducers: (builder) => {
        builder
            // @ts-expect-error action type is not correct
            .addCase(
                "api/executeQuery/fulfilled",
                (
                    state,
                    action: {
                        payload: Workspace[];
                        meta: { arg: { endpointName: string } };
                    },
                ) => {
                    if (
                        action.meta.arg.endpointName ===
                        api.endpoints.getWorkspaces.name
                    ) {
                        state.selectedWorkspace =
                            action.payload.find(
                                (workspace) =>
                                    workspace.id ===
                                    state.selectedWorkspace?.id,
                            ) ?? action.payload[0];
                    }
                },
            )
            // @ts-expect-error action type is not correct
            .addCase(
                "api/executeMutation/fulfilled",
                (
                    state,
                    action: {
                        payload: Workspace;
                        meta: { arg: { endpointName: string } };
                    },
                ) => {
                    if (
                        action.meta.arg.endpointName ===
                            api.endpoints.updateWorkspace.name ||
                        action.meta.arg.endpointName ===
                            api.endpoints.updateLensContacts.name
                    ) {
                        if (action.payload.id === state.selectedWorkspace?.id) {
                            state.selectedWorkspace = action.payload;
                            return;
                        }
                    }
                },
            );
    },
});

// Selectors
export const getSelectedWorkspace = (state: RootState): Workspace | undefined =>
    state.workspace.selectedWorkspace;

export const { setSelectedWorkspace, workspaceUnavailable } =
    workspaceSlice.actions;
export default workspaceSlice.reducer;
